import { EMPTY_STRING } from '../../../constants/common'
import i18n from '../../../i18n'

const MOCK_MATCH_INFORMATION_TEXT = {
  de: 'Wir prüfen ausschließlich, ob Wohnung und Wohnungssuche objektiv zusammenpassen — Einzugstermin, Budget, Haushaltsgröße und Ihre Anforderungen. Wir erheben keine Angaben zu Alter, Herkunft, Religion, Familienstand oder Gesundheit. Ihre Angaben werden 6 Monate nach Abschluss der Vermietung gelöscht.',
  en: 'We check only whether the flat and what you are looking for objectively match — move-in date, budget, household size and your requirements. We collect no data on age, origin, religion, marital status or health. Your answers are deleted 6 months after the letting is completed.',
  version: '1.0',
}

const MOCK_MATCH_INFORMATION_TEXT_SAVE_LATENCY = 400

export function getMockMatchInformationTextSettings() {
  return { ...MOCK_MATCH_INFORMATION_TEXT }
}

export function getMockMatchInformationText() {
  const [language] = (i18n.language ?? EMPTY_STRING).split('-')

  return {
    text:
      MOCK_MATCH_INFORMATION_TEXT[language] ?? MOCK_MATCH_INFORMATION_TEXT.en,
    version: MOCK_MATCH_INFORMATION_TEXT.version,
  }
}

export function patchMockMatchInformationText({ de, en }) {
  return new Promise(resolve => {
    setTimeout(() => {
      const [major] = MOCK_MATCH_INFORMATION_TEXT.version.split('.')

      Object.assign(MOCK_MATCH_INFORMATION_TEXT, {
        de,
        en,
        version: `${major}.${Number(MOCK_MATCH_INFORMATION_TEXT.version.split('.')[1]) + 1}`,
      })

      resolve()
    }, MOCK_MATCH_INFORMATION_TEXT_SAVE_LATENCY)
  })
}
